<template>
  <img
    class="divii-logo"
    :src="logoSrc"
    alt="Divii"
    :width="width"
    :height="height"
  />
</template>

<script>
import logoAsset from '@/assets/Divii-Logo-Primary.svg'

export default {
  name: 'DiviiLogo',
  props: {
    width:  { type: [Number, String], default: 92 },
    height: { type: [Number, String], default: 'auto' },
  },
  computed: {
    logoSrc() {
      if (!logoAsset) return '/divii-logo.png'
      if (/^(https?:|data:)/i.test(logoAsset)) return logoAsset
      try {
        return new URL(logoAsset, window.location.href).href
      } catch (e) {
        return logoAsset
      }
    },
  },
}
</script>

<style scoped>
/* Logo only appears when printing / saving as PDF.
   Hidden in the live preview so the on-screen tool stays uncluttered. */
.divii-logo {
  display: none;
  vertical-align: middle;
}
@media print {
  .divii-logo {
    display: inline-block;
  }
}
</style>
